<script>
import { mediaWatchEventListenerPonyfill } from "@/polyfills";

export default {
  name: "TouchOrMouseElement",
  data() {
    return {
      mediaWatch: null,
      isMouse: true
    };
  },
  mounted() {
    this.mediaWatch = window.matchMedia("(pointer:fine)");
    this.handleChange(this.mediaWatch);
    mediaWatchEventListenerPonyfill.addEventListener(this.mediaWatch, this.handleChange);
  },
  beforeUnmount() {
    if (!this.mediaWatch) {
      return;
    }

    mediaWatchEventListenerPonyfill.removeEventListener(this.mediaWatch, this.handleChange);
  },
  methods: {
    handleChange(mq) {
      this.isMouse = mq.matches === true;
    }
  }
};
</script>

<template>
  <span class="d-inline-block">
    <template v-if="isMouse">
      <slot name="mouse"></slot>
    </template>
    <template v-else>
      <slot name="touch"></slot>
    </template>
  </span>
</template>
